import React, { useState } from 'react';
import AdSpaceMediaTypesAdminList from './components/AdSpaceMediaTypesAdminList';
import AdSpaceMediaTypesAdminAddMediaTypePage from './components/AdSpaceMediaTypesAdminAddMediaTypePage';
import { Box, Tabs, Tab } from '@mui/material';



const AdSpaceMediaTypesAdminPage: React.FC = () => {
  const [tab, setTab] = useState(0);

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs value={tab} onChange={handleTabChange} aria-label="AdSpaces admin tabs">
        <Tab label="List adSpace MediaTypes" />
        <Tab label="Insert adSpace MediaType" />
      </Tabs>
      <Box sx={{ mt: 2 }}>
        {tab === 0 && <AdSpaceMediaTypesAdminList />}
        {tab === 1 && <AdSpaceMediaTypesAdminAddMediaTypePage />}
      </Box>
    </Box>
  );
};

export default AdSpaceMediaTypesAdminPage;